export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
// Modules
import cancellation from './cancellation/route-names'
// import connectivityChecker from './connectivity/route-names'
import contact from './contact/route-names'
import contract from './contract/route-names'
import customer from './customer/route-names'
import invoice from './invoice/route-names'
import productInventory from './product-inventory/route-names'
import reservation from './reservation/route-names'
import search from './search/route-names'
import sipcentric from './sipcentric/route-names'
import sms from './sms/route-names'
import staffMember from './staff-member/route-names'
import bespoke from './bespoke/route-names'
import bundle from './bundle/route-names'
import scheduledReport from './scheduled-report/route-names'

export * from './cancellation/route-names'
// export * from './connectivity/route-names'
export * from './contact/route-names'
export * from './contract/route-names'
export * from './customer/route-names'
export * from './invoice/route-names'
export * from './product-inventory/route-names'
export * from './reservation/route-names'
export * from './search/route-names'
export * from './sipcentric/route-names'
export * from './sms/route-names'
export * from './staff-member/route-names'
export * from './bespoke/route-names'
export * from './bundle/route-names'
export * from './scheduled-report/route-names'

export default {
    LOGIN,
    LOGOUT,
    cancellation,
    // connectivityChecker,
    contact,
    contract,
    customer,
    invoice,
    productInventory,
    reservation,
    search,
    sipcentric,
    sms,
    staffMember,
    bespoke,
    bundle,
    scheduledReport,
}
